import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Clear from '@material-ui/icons/Clear';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import AttachFileOutlined from '@material-ui/icons/AttachFileOutlined';

import Button from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';

const styles = {
	pathInput: {
		width: 'calc(100% - 48px)',
		marginLeft: '5px',
	},
};

class FileUpload extends Component {
	fileInput = React.createRef();

	handleClick = () => {
		this.fileInput.current.click();
	};

	handleClear = () => {
		this.fileInput.current.value = null;
		if (this.props.onClear) {
			this.props.onClear();
		}
	}

	handleChange = (event) => {
		this.props.handleChange(event);
		this.fileInput.current.value = null;
	}

	render() {
		const {
			classes,
			label,
			allowedFormats,
			helperText,
			errorText,
			fileName,
			hasFile,
			isError,
		} = this.props;

		return (
			<div className="logo-upload-container">
				<Tooltip
					arrow
					title={this.props.tooltip || ''} >
					<Button justIcon
						round
						color="warning"
						onClick={this.handleClick}
					>
						<AttachFileOutlined />
					</Button>
				</Tooltip>
				<CustomInput
					labelText={label}
					error={isError}
					helperText={(isError && errorText) ? errorText : helperText}
					formControlProps={{
						fullWidth: true,
						className: classes.pathInput,
					}}
					inputProps={{
						disabled: true,
						value: fileName,
						type: "text",
						endAdornment: hasFile && (
							<InputAdornment position="end">
								<Button
									justIcon
									simple
									onClick={this.handleClear}
								>
									<Clear />
								</Button>
							</InputAdornment>
						)
					}}
				/>
				<input
					type="file"
					accept={allowedFormats}
					onChange={this.handleChange}
					ref={this.fileInput} />
			</div>
		);
	}
}

FileUpload.propTypes = {
	classes: PropTypes.object.isRequired,
	label: PropTypes.string,
	allowedFormats: PropTypes.string,
	helperText: PropTypes.string,
	errorText: PropTypes.string,
	fileName: PropTypes.string,
	hasFile: PropTypes.bool,
	isError: PropTypes.bool,
	onClear: PropTypes.func,
	handleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(FileUpload);

